/**
 * ActionRow component.
 * Contains the Reveal button and any other action buttons.
 */

import './ActionRow.css';

export interface ActionRowProps {
    /** Whether the puzzle is finished (solved/missed/revealed) */
    isFinished: boolean;
    /** Whether currently loading/animating */
    isLoading: boolean;
    /** Callback to reveal solution */
    onReveal: () => void;
    /** Callback to share result */
    onShare?: () => void;
    /** Whether share was copied */
    shareCopied?: boolean;
}

export function ActionRow({
    isFinished,
    isLoading,
    onReveal,
    onShare,
    shareCopied,
}: ActionRowProps) {
    return (
        <div className="action-row">
            {!isFinished && (
                <button
                    className="action-button action-button--secondary"
                    onClick={onReveal}
                    disabled={isLoading}
                >
                    Reveal
                </button>
            )}

            {isFinished && onShare && (
                <button
                    className="action-button action-button--primary"
                    onClick={onShare}
                    disabled={isLoading}
                >
                    {shareCopied ? 'Copied!' : 'Share'}
                </button>
            )}
        </div>
    );
}
